<template>
  <vs-card>
    <ACard>
      <div class="flex justify-between">
        <div>
          <a-button class="p-0" type="link" ghost icon="left" @click="$router.push('/task/list')">Back to tasks</a-button>
        </div>
        <div class="space-x-2">
          <a-button type="primary" ghost @click="$router.push('/task/type')" style="border-radius: 3px ">Task types</a-button>
          <a-button type="primary" @click="AddTask" style="border-radius: 3px">New task list</a-button>
        </div>
      </div>
    </ACard>
    <XTable class="mt-3"
            :model="model"
            ref="task"
            :options="{placeholder:'Search task list',noContent: 'No tasks',is_row_selection: false,is_load_req: true}"
            @clickRow="editTask"
    >

      <span slot="task_title" slot-scope="text,record">
        <a-button type="link" class="p-0" @click="is_click_add_time = false;$router.push(`/task/lists/template/${text.record.id}`)">{{ text.record.title }}</a-button>
      </span>
      <span slot="action" slot-scope="text,record" class="flex space-x-3">
        <a-dropdown>
          <a-menu slot="overlay">
            <a-menu-item key="1" @click="editTask(text.record)"> <a-icon type="edit" />Edit</a-menu-item>
            <a-menu-item key="2" @click="OpenDeleteTask(text.record)"> <a-icon type="delete" />Delete</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px" @click="is_click_add_time = false"> Actions <a-icon type="down" /> </a-button>
        </a-dropdown>
      </span>

    </XTable>
    <a-modal title="New task list" :width="700" centered :visible="visible" @cancel="visible = false">
      <a-form :form="form" @submit.prevent="handleTask">

        <a-form-item label="Title" has-feedback>
          <a-input
                v-decorator="['title',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                placeholder="Enter name..."
          />
        </a-form-item>

        <a-form-item label="Description" has-feedback>
          <a-textarea
            v-decorator="['description']"
            :rows="10"
            placeholder="Enter description..."
          />
        </a-form-item>

        <a-form-item label="Practice Area" has-feedback>
          <a-select
            placeholder="Select a task type"
            style="width: 100%"
            allowClear
            class="select"
            v-decorator="['practice_area',{ initialValue: null }]"
          >
            <a-select-option v-for="task in task_types" :value="task.id">
              {{ task.title }}
            </a-select-option>
          </a-select>
        </a-form-item>

        <div id="task-footer">
          <a-divider/>
          <div class="flex space-x-2">
            <a-button type="primary"  style="border-radius: 3px" html-type="submit">Save tasks</a-button>
            <a-button type="primary" ghost style="border-radius: 3px" @click="visible = false">Cancel</a-button>
          </div>
        </div>

      </a-form>
    </a-modal>

    <deleteItem
      :url="`/task/task-list/${temp_row}/`"
      subject="Task lists"
      :ele="$refs.task"
      ref="taskDelete"
    />

  </vs-card>
</template>

<script>

import XTable from '../../components/x-table/XTable'
import * as TableCol from './taskListTbl'
import mixin from  '../mixin/mixin'
import axios from '@/axios'
import deleteItem from '../communications/deleteItem'


export default {
  name: "TaskLists",
  mixins:[mixin],
  components:{
    XTable,
    deleteItem,
  },
  data(){
    return{
      model: null,
      visible: false,
      task_types: [],
      temp_row: undefined,
      edit_mode: false
    }
  },
  methods:{
    AddTask(){
      this.visible = true
      this.edit_mode = false
    },
    handleTask(){
      this.form.validateFields(async(err,values)=>{
        if(!err){
          try{
            this.$vs.loading()
            if(!values.practice_area) values.practice_area = null
            if(this.edit_mode){
              const id = this.temp_row
              await axios.put(`/task/task-list/${id}/`,values)
            }else
              await axios.post('/task/task-list/',values)
            this.form.resetFields()
            this.visible = false
            await this.$refs.task.fetch()
          }catch (e){
            this.$message.error('')
            this.visible = true
          }finally {
            this.$vs.loading.close()
          }
        }
      })
    },
    OpenDeleteTask(record){
      this.temp_row = record.id
      this.$refs.taskDelete.open = true
    },
    editTask(record){
      this.temp_row = record.id
      this.edit_mode = true
      if(this.is_click_add_time){
        this.visible = true
        record.practice_area = record.practice_area ? record.practice_area.id : undefined
        this.$nextTick(()=>this.form.setFieldsValue(record))
      }else
        this.is_click_add_time = true

    },
    async getTaskType(){
      try{
        const { data } = await axios.get('/dictionary/practice-area/')
        this.task_types = data
      }catch (e){
        this.$message.error('Error reviving information')
      }
    }
  },
  mounted() {
    this.is_click_add_time = true
    this.getTaskType()
  },
  created() {
    this.model = TableCol.default
  }
}
</script>

<style >
  @import "../style/style.css";
  .ant-btn-background-ghost.ant-btn-link,.ant-btn-link{
    color: #3A3DBE !important;
   }
</style>
